// Timestamp fixo por carregamento do app: força buscar a imagem nova após reload sem refazer download a cada render.
// ponytail: a API não envia updated_at da promoção; se passar a enviar, usar ele como versão.
const APP_LOAD_TS = Date.now();

export function cacheBust(url?: string) {
  // Ignora data/blob URLs e URLs com query (ex.: S3 assinada, onde parâmetro extra quebra a assinatura)
  if (!url || !/^https?:\/\//.test(url) || url.includes('?')) return url;
  return `${url}?v=${APP_LOAD_TS}`;
}
